import { render } from "./HalamanAbout.vue?vue&type=template&id=6b3f5b9d"
import script from "./HalamanAbout.vue?vue&type=script&lang=js"
export * from "./HalamanAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__